import { type MouseEventHandler, memo, useCallback } from 'react';

import { ArrowRightIcon } from '@air/design-icons';
import { Button } from '@air/primitive-button';

import { type ClipDiscussion } from '~/components/Annotations/shared/types';
import { useDiscussionPanelContext } from '~/components/AssetModal/shared/context/DiscussionsPanelContext/DiscussionsPanelContext';
import { useAssetModalRightPanel } from '~/components/AssetModalV2/AssetModalRightPanelContextProvider';

export type AnnotationReplyButtonProps = {
  discussion: ClipDiscussion;
};

export const AnnotationReplyButton = memo(({ discussion }: AnnotationReplyButtonProps) => {
  const { setReplyingDiscussionId } = useDiscussionPanelContext();
  const { showRightPanelTab } = useAssetModalRightPanel();

  const handleReplyClick = useCallback<MouseEventHandler<HTMLButtonElement>>(
    (event) => {
      event.stopPropagation();
      showRightPanelTab('comments');
      setReplyingDiscussionId(discussion.id);
    },
    [discussion.id, setReplyingDiscussionId, showRightPanelTab],
  );

  return (
    <Button
      appearance="ghost"
      color="gray"
      className="-ml-2"
      data-testid="ANNOTATION_REPLY_BUTTON"
      onClick={handleReplyClick}
      suffix={<ArrowRightIcon size="sm" />}
      size="small"
    >
      Reply
    </Button>
  );
});

AnnotationReplyButton.displayName = 'AnnotationReplyButton';
